export const getSubjects = /* GraphQL */ `
  query GetSubjects(
    $contact_outcomes: [String]
    $deal_id: [Int]
    $deal_status: String
    $deal_status_raw: String
    $email_address: String
    $enrollment_status: String
    $enrollment_status_raw: String
    $filters: [subject_filter_input]
    $id: [Int]
    $integrations: GetSubjectsIntegrationsInput
    $is_rankings: Boolean
    $last_contact_outcomes: [String]
    $limit: Int
    $next_task_id: [String]
    $next_touchpoint: [String]
    $offset: Int
    $phone_number: [String]
    $protocol_id: [Int]
    $questionnaire_id: [Int]
    $questionnaire_outcome: [String]
    $recruitment_id: [Int]
    $segment_id: [Int]
    $site_id: [Int]
    $sorting: [subject_sort_input]
    $statuses: [String]
    $study_id: [Int]
    $subject_contacts_limit: Int
    $workflow_id: [Int]
  ) {
    getSubjects(
      contact_outcomes: $contact_outcomes
      deal_id: $deal_id
      deal_status: $deal_status
      deal_status_raw: $deal_status_raw
      email_address: $email_address
      enrollment_status: $enrollment_status
      enrollment_status_raw: $enrollment_status_raw
      filters: $filters
      id: $id
      integrations: $integrations
      is_rankings: $is_rankings
      last_contact_outcomes: $last_contact_outcomes
      limit: $limit
      next_task_id: $next_task_id
      next_touchpoint: $next_touchpoint
      offset: $offset
      phone_number: $phone_number
      protocol_id: $protocol_id
      questionnaire_id: $questionnaire_id
      questionnaire_outcome: $questionnaire_outcome
      recruitment_id: $recruitment_id
      segment_id: $segment_id
      site_id: $site_id
      sorting: $sorting
      statuses: $statuses
      study_id: $study_id
      subject_contacts_limit: $subject_contacts_limit
      workflow_id: $workflow_id
    ) {
      rankings {
        id
        row_num
      }
      subjects {
        active_enrollment_status
        alcohol_use_frequency
        bmi
        ccid
        created_at
        crid
        current_study_name
        date_of_birth
        diet_type
        ethnicity
        first_name
        full_name_first
        full_name_last
        gender
        height_cm
        height_in
        id
        is_possible_duplicate
        last_contact_outcomes
        last_contact_started_at
        last_name
        last_touchpoint
        lead_created_at
        lifestyle_notes
        middle_name
        next_appt
        next_touchpoint
        physical_activity_level
        preferred_language
        race
        ready_to_contact
        recruitment_source_name
        sleep_hours
        smoker_status
        sms_opt_in
        statuses
        stress_level
        subject_contacts {
          channel
          city
          contact_id
          created_at
          duration_seconds
          ended_at
          first_name
          full_name_first
          full_name_last
          last_name
          next_task_id
          next_touchpoint
          outcome
          outcomes
          phone_number
          purpose
          recording_bucket
          recording_key
          recording_url
          recruitment_id
          recruitment_source_name
          started_at
          subject_id
          transcript_bucket
          transcript_key
          transcript_url
          updated_at
          wss_url
        }
        subject_enrollment_status {
          ava_bot_alias_id
          ava_bot_config
          ava_bot_id
          ava_state_machine
          ccid
          contact_flow_id
          created_at
          enrollment_status
          id
          study_ava_bot_alias_id
          study_ava_bot_config
          study_ava_bot_id
          study_ava_state_machine
          study_ccid
          study_contact_flow_id
          study_enrollment_status_is_complete
          study_enrollment_status_priority
          study_id
          study_name
          study_visit_name
        }
        subject_phone_numbers {
          created_at
          phone_number
          phone_type
          preferred
          sms_opt_in
        }
        subject_recruitment_sources {
          id
          source_name
        }
        subject_statuses {
          id
          status
        }
        subject_workflows {
          id
          tasks_json
          workflow_id
          workflow_name
          workflow_tasks_json
        }
        title
        updated_at
        weight_kg
        weight_lb
      }
      total_count
    }
  }
`;

export const getSubjectContacts = /* GraphQL */ `
  query GetSubjectContacts(
    $contact_id: [String]
    $filters: [subject_contacts_filter_input]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $outcomes: [String]
    $sorting: [subject_contacts_sort_input]
    $subject_id: [Int]
  ) {
    getSubjectContacts(
      contact_id: $contact_id
      filters: $filters
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      outcomes: $outcomes
      sorting: $sorting
      subject_id: $subject_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      subject_contacts {
        ai_platform
        channel
        city
        contact_id
        duration_seconds
        ended_at
        first_name
        full_name_first
        full_name_last
        last_name
        next_task_id
        next_touchpoint
        outcome
        outcomes
        phone_number
        recording_key
        recruitment_id
        started_at
        subject_id
        transcript_key
      }
      total_count
    }
  }
`;

export const getSubjectContactsWithSummary = /* GraphQL */ `
  query GetSubjectContacts(
    $contact_id: [String]
    $filters: [subject_contacts_filter_input]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $outcomes: [String]
    $sorting: [subject_contacts_sort_input]
    $subject_id: [Int]
  ) {
    getSubjectContacts(
      contact_id: $contact_id
      filters: $filters
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      outcomes: $outcomes
      sorting: $sorting
      subject_id: $subject_id
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      subject_contacts {
        ai_platform
        channel
        city
        contact_id
        duration_seconds
        ended_at
        first_name
        full_name_first
        full_name_last
        last_name
        next_task_id
        next_touchpoint
        outcome
        outcomes
        phone_number
        recording_key
        recruitment_id
        started_at
        subject_id
        summary
        transcript_key
      }
      total_count
    }
  }
`;

export const getSubjectWorkflows = /* GraphQL */ `
  query GetSubjectWorkflows(
    $subject_id: [Int]
  ) {
    getSubjects(
      id: $subject_id
    ) {
      subjects {
        id
        subject_workflows {
          created_at
          id
          tasks_json
          updated_at
          workflow_id
          workflow_name
          workflow_tasks_json
        }
      }
    }
  }
`;

export const getSubjectNotes = /* GraphQL */ `
  query GetSubjectWorkflows(
    $subject_id: [Int]
  ) {
    getSubjects(
      id: $subject_id
    ) {
      subjects {
        id
        subject_notes {
          created_at
          id
          note
          subject_id
          updated_at
        }
      }
    }
  }
`;

export const getDashboardStats = /* GraphQL */ `
  query GetDashboardStats {
    getCallAnalysis {
      average_duration_seconds
      dropped
      successful
      total_calls
    }
    getTotalOutreach {
      monthly_outreach {
        label
        value
      }
      total_outreach
      weekly_outreach {
        label
        value
      }
      yearly_outreach {
        label
        value
      }
    }
  }
`;

export const getSegments = /* GraphQL */ `
  query GetSegments(
    $filters: [segment_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [segment_sort_input]
  ) {
    getSegments(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      segments {
        age_max
        age_min
        allergies {
          allergen_description
          allergen_type
          cc_allergen_id
          ccid
          created_at
          description
          id
          is_default
          name
          updated_at
        }
        bmi_category
        bmi_max
        bmi_min
        conditions {
          category_description
          category_name
          cc_category_id
          ccid
          created_at
          description
          icd9_code
          id
          is_child_bearing
          name
          updated_at
        }
        created_at
        ethnicity
        gender
        height_max_in
        height_min_in
        id
        interaction_frequency
        last_interaction_date
        location_coordinates
        location_radius_miles
        medications {
          category_name
          ccid
          created_at
          default_route_id
          default_route_id_name
          description
          id
          is_child_bearing
          name
          updated_at
        }
        name
        participation_status
        preferred_contact_method
        preferred_language
        previous_trial_participation
        race
        response_status
        smoker_status
        subject_filters_json
        trial_phase
        updated_at
        weight_max_lb
        weight_min_lb
      }
      total_count
    }
  }
`;

export const getBookings = /* GraphQL */ `
  query GetBookings(
    $filters: [booking_filter_input]
    $id: [Int]
    $is_rankings: Boolean
    $limit: Int
    $offset: Int
    $sorting: [booking_sort_input]
  ) {
    getBookings(
      filters: $filters
      id: $id
      is_rankings: $is_rankings
      limit: $limit
      offset: $offset
      sorting: $sorting
    ) {
      bookings {
        email_address
        fh_booked_at
        fh_booking_id
        fh_parent_name
        fh_status
        fh_total_revenue
        id
        name
        subject_id
      }
      total_count
    }
  }
`;
